import { render, staticRenderFns } from "./IcoPeople2.vue?vue&type=template&id=74e78279"
import script from "./IcoPeople2.vue?vue&type=script&lang=js"
export * from "./IcoPeople2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports